(ns app.bundle-social-linkedin.platform
  "LinkedIn profiles and company pages through bundle.social: a public
   post with one video or image and the caption as its text.

   Only data and pure functions, see `app.bundle-social.platforms` for
   the keys. After the OAuth the user picks the personal profile or the
   company pages to post on, like Facebook pages."
  (:require [app.bundle-social.text :as text]))

(defn icon
  "Font Awesome's linkedin-in brand icon."
  [classes]
  [:svg {:xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 448 512"
         :fill "currentColor"
         :aria-hidden "true"
         :class classes}
   [:path {:d "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"}]])

(def max-title-length
  200)

(defn post-data
  "The `data.LINKEDIN` entry of a bundle.social post. LinkedIn requires
   the text; the schedule command ensures it. The visibility is the
   one chosen on the scheduling page.

   A video gets a title (`mediaTitle`, the story's name unless changed
   in the options), else LinkedIn shows the post date below it, and the
   story's preview image as its cover (`thumbnail`)."
  [{:keys [media title text upload-id options cover-url]}]
  (let [video? (= :video media)
        video-title (or (:title options) (not-empty title))]
    (cond-> {:text text
             :uploadIds [upload-id]
             :privacy (:privacy options "PUBLIC")}
      (and video? video-title)
      (assoc :mediaTitle (text/shorten video-title max-title-length))

      (and video? cover-url)
      (assoc :thumbnail cover-url))))

(def platform
  {:social-platform/id "LINKEDIN"
   :social-platform/key :linkedin
   :social-platform/name "LinkedIn"
   :social-platform/account-noun "LinkedIn profile or page"
   :social-platform/channel-noun "profile or page"
   :social-platform/channel-nouns "profiles and pages"
   :social-platform/count-noun "account"
   :social-platform/count-nouns "accounts"
   :social-platform/icon icon
   :social-platform/text-class ["text-sky-700"]
   :social-platform/pill-class ["bg-sky-50" "border-sky-200" "text-sky-800"]
   :social-platform/launched? true
   :social-platform/connect-card
   {:eyebrow "Video & image posts"
    :description "Connect your LinkedIn profile or company pages for scheduled video and image posts."
    :button-text "Connect LinkedIn"
    :style {:card-class ["border-sky-200" "bg-sky-50" "hover:border-sky-300"]
            :eyebrow-class ["bg-white/70" "text-sky-700" "ring-sky-100"]
            :icon-class ["bg-white" "text-sky-700" "ring-sky-200"]
            :title-class ["text-gray-900"]
            :description-class ["text-gray-600"]
            :button-class ["bg-sky-700" "text-white" "hover:bg-sky-800"]
            :rail-class ["bg-sky-700"]}}
   :social-platform/post-data post-data
   ;; LinkedIn takes videos from 3 s to 30 minutes and requires a text
   ;; of up to 3,000 characters
   ;; (https://info.bundle.social/api-reference/platforms/linkedin).
   :social-platform/post-types
   [{:post-type/id "POST"
     :post-type/kind :linkedin-post
     :post-type/label "LinkedIn post"
     :post-type/group-label "LinkedIn"
     :post-type/media #{:video :image}
     :post-type/min-duration-seconds 3
     :post-type/max-duration-seconds 1800
     :post-type/caption? true
     :post-type/text-required? true
     :post-type/max-text-length 3000
     :post-type/cover? true
     ;; Decided with Tobias on 2026-09-29: the visibility is chosen per
     ;; post. LinkedIn only knows connections for personal profiles.
     :post-type/options
     [{:option/key :privacy
       :option/label "Visibility"
       :option/hint "Connections only is meant for personal profiles; LinkedIn may reject it for company pages."
       :option/choices [{:choice/value "PUBLIC"
                         :choice/label "Public"}
                        {:choice/value "CONNECTIONS"
                         :choice/label "Connections only"}]}
      {:option/key :title
       :option/type :text
       :option/label "Video title"
       :option/max-length max-title-length
       :option/default :media-name
       :option/hint "Videos only, shown below the video. Empty uses the media's name."}]}]})
